module.exports = __webpack_public_path__ + "img/Rolling10_Regular.d9a88c4c.png";